<template>
  <div class="contact" id="maklerbetreuung">
    <!-- <div class="grid-container nopadding"> -->
      <div class="grid-x">
        <div class="cell large-offset-1 small-12 large-10 relative">
          <!-- <h2>Weil gute Kontakte zählen: <br>Die ERGO Maklerbetreuung ist für Sie da.</h2> -->
          
          <div class="grid-x">
            <div class="cell large-offset-1 small-12 large-10 relative">
              <h2>Weil gute Kontakte zählen:<br> Die ERGO Maklerbetreuung ist für Sie da.</h2>
              <div class="card">
                <div class="grid-x">
                  <div class="cell small-12 large-6">
                    <img src="@/assets/Katrin-Schreiner_Portrait.jpg"/>
                  </div>
                  <div class="cell small-12 large-6 relative content">
                    <h3 class="titel">„Meine Kollegen und ich sind an sechs Standorten in Deutschland für Sie da.“</h3>
                    <p class="subtitel">Katrin Schreiner, Mitarbeiterin Vertriebsunterstützung Makler</p>
                    <p class="info-text">Unterstützung rund um Produkte, Vertrieb, Zusammenarbeit – und natürlich die Akquise-App? Wir helfen gern. Verlassen Sie sich drauf – und nehmen Sie einfach Kontakt zu uns auf.</p>
                    <a href="tel:02114774638" @click="$store.trackingClick('Service_Call');"><div class="btn big-red"><span>Telefon: <span v-if="!state.app.isVertrieb">0211 477-4638</span><span v-else><br>0211 477-7016</span></span></div></a>
                    <a v-if="!state.app.isVertrieb" href="mailto:ServiceTeamLeben@ergo.de" @click="$store.trackingClick('Service_Email');"><div class="btn big-red no-margin link"><span>E-Mail: ServiceTeamLeben@ergo.de</span></div></a>
                    <a v-else href="mailto:ServiceTeamFinanzvertriebe@ergo.de"><div class="btn big-red no-margin link"><span>E-Mail:<br>ServiceTeamFinanzvertriebe@ergo.de</span></div></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Contact',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="stylus" scoped>
  .contact {
    padding 8.7em 0 12.6em

    @media screen and (max-width: 39.9375em) {
      padding 3em 1.7em 2em
    }
  }
  h3 {
    font-size 1.8em
    font-weight bold
    font-family: 'FedraSerifAPro'
    color #8E0038
    line-height 1.21em
  }

  h2 {
    font-size 2em
    font-weight bold
    text-align center
    margin-bottom 1em
  }

  .card {
    border-radius .4em
    box-shadow 0 0.4em 1em 0.2em rgba(0,0,0,0.3)
    .content {
      padding 2.1em
      p {
        font-size 1.14em
        
        &.titel {
          color #8E0038
          font-weight bold
          margin-bottom 0
        }

        &.subtitel {
          font-size .93em
          font-style italic
          font-weight lighter
          margin-bottom 2.8em
        }

        &.info-text {
          margin-bottom 3em
        }
      }

      .btn {
        &.big-red {
          background-color #BE1528
          padding 1.1em 3.2em
          text-align center
          border-radius 2em
          box-shadow 0 .3em 1em .3em rgba(0,0,0,0.5)
          margin-bottom 1.5em

          &.no-margin {
            margin 0
          }

          span {
            font-size 1.14em
            color #ffffff
            font-weight bold
          }
        }
      }
      @media screen and (max-width: 39.9375em) {
        text-align:center
      }
    }
  }
</style>